import type { QueryClient } from '@tanstack/react-query';

import { getDataConnect } from 'firebase/data-connect';
import { connectorConfig } from '@dataconnect/generated';

// Firebase Data Connect caches query results in _queryManager.subscriptionCache with
// fetchPolicy PREFER_CACHE by default. Without clearing it, executeQuery returns the
// stale in-memory result instead of hitting the network, so React Query's
// invalidateQueries() ends up refreshing with the same old data. Clearing the
// subscription cache first forces the next executeQuery call to go to the server.
export async function invalidateAll(queryClient: QueryClient): Promise<void> {
  try {
    const dc = getDataConnect(connectorConfig);

    (dc as unknown as { _queryManager?: { subscriptionCache?: { clear: () => void } } })
      ._queryManager?.subscriptionCache?.clear();
  } catch {
    // DC may not be initialized yet in all environments — safe to ignore.
  }
  await queryClient.invalidateQueries();
}
